import Language from "../systemsettings/language";

const LanguagePage = () => {
  return (
    <div className="row">
      <Language />
    </div>
  );
};

export default LanguagePage;
